/**
 * Preditiva Gult Premium V2
 * Copyright (c) 2026 Preditiva. Todos os direitos reservados.
 * Tema proprietario - uso exclusivo clientes Preditiva.
 */
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.category-slider__wrapper');
  
  sliders.forEach(slider => {
    const track = slider.querySelector('.category-slider__track');
    const leftArrow = slider.querySelector('.category-slider__arrow--left');
    const rightArrow = slider.querySelector('.category-slider__arrow--right');
    
    if (!track || !leftArrow || !rightArrow) return;
    
    const scrollAmount = 300; // Adjust based on item width

    leftArrow.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
    
    // Optional: Hide arrows if at beginning/end
    track.addEventListener('scroll', () => {
      if (track.scrollLeft <= 0) {
        leftArrow.style.opacity = '0';
        leftArrow.style.pointerEvents = 'none';
      } else {
        leftArrow.style.opacity = '';
        leftArrow.style.pointerEvents = '';
      }
      
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
        rightArrow.style.opacity = '0';
        rightArrow.style.pointerEvents = 'none';
      } else {
        rightArrow.style.opacity = '';
        rightArrow.style.pointerEvents = '';
      }
    });
    
    // Trigger scroll event to set initial state
    track.dispatchEvent(new Event('scroll'));
  });
});
